import { Pipe, PipeTransform } from '@angular/core';
import { NOT_AVAILABLE, UNKNOWN } from '../../common/constants/template.constant';
import { startCase, lowerCase } from 'lodash';

@Pipe({
    name: 'region',
    standalone: false
})
export class RegionPipe implements PipeTransform {
  transform(value: string): string {
    return value === UNKNOWN ? NOT_AVAILABLE : startCase(lowerCase(value));
  }
}
